import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ZendraLocalizationPipe } from '../pipes/zendra-localization.pipe';

export interface DropdownMenuItem {
  id: string;
  label: string;
}

@Component({
  selector: 'zn-dropdown-menu',
  standalone: true,
  imports: [CommonModule, ZendraLocalizationPipe],
  templateUrl: './zn-dropdown-menu.component.html',
  styleUrl: './zn-dropdown-menu.component.scss'
})
export class ZnDropdownMenuComponent {
  @Input() items: DropdownMenuItem[] = [];
  @Input() isVisible: boolean = false;
  @Input() position: { x: number; y: number } = { x: 0, y: 0 };

  @Output() itemSelected = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();
  @Input() anchorRect!: DOMRect;

  dropdownStyle: { top: string; left: string } = {
    top: '0px',
    left: '0px',
  };

private readonly DROPDOWN_HEIGHT = 260; // ajustá a tu diseño

ngOnChanges() {
  if (this.isVisible && this.anchorRect) {
    this.calculatePosition();
  }
}

private calculatePosition(): void {
  const viewportHeight = window.innerHeight;

  const spaceBelow = viewportHeight - this.anchorRect.bottom;
  const spaceAbove = this.anchorRect.top;

  const openUpwards = spaceBelow < this.DROPDOWN_HEIGHT && spaceAbove > spaceBelow;

  const top = openUpwards
    ? this.anchorRect.top - this.DROPDOWN_HEIGHT
    : this.anchorRect.bottom;

  this.dropdownStyle = {
    top: `${Math.max(8, top)}px`,
    left: `${this.anchorRect.left}px`,
  };
}

  onItemClick(itemId: string): void {
    this.itemSelected.emit(itemId);
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('dropdown-backdrop')) {
      this.closed.emit();
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.isVisible) {
      this.closed.emit();
    }
  }
}
